'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('../../../../dist-es6/client/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const PointPlotterDirective=require('../../../../dist-es6/client/directives/plotting/pointPlotterDirective');let

IncidentPlotterDirective=function(_PointPlotterDirectiv){_inherits(IncidentPlotterDirective,_PointPlotterDirectiv);function IncidentPlotterDirective(){_classCallCheck(this,IncidentPlotterDirective);return _possibleConstructorReturn(this,_PointPlotterDirectiv.apply(this,arguments))}_createClass(IncidentPlotterDirective,[{key:'objectBindings',get:function()
{
return['snapToPoints','verticalAxis','pointRadius'].concat(_toConsumableArray(_PointPlotterDirectiv.prototype.objectBindings));
}},{key:'controller',get:function()

{
return IncidentPlotterController;
}}]);return IncidentPlotterDirective}(PointPlotterDirective);let


IncidentPlotterController=function(_PointPlotterDirectiv2){_inherits(IncidentPlotterController,_PointPlotterDirectiv2);_createClass(IncidentPlotterController,null,[{key:'$inject',get:function()
{
return['$scope','$element','$compile'];
}}]);

function IncidentPlotterController($scope,$element,$compile){_classCallCheck(this,IncidentPlotterController);var _this2=_possibleConstructorReturn(this,
_PointPlotterDirectiv2.call(this,$scope,$element,$compile));

_this2.hitAreaWidth=_this2.pointRadius*2;
_this2._incidentIconHeight=_this2.pointRadius*4;return _this2;
}IncidentPlotterController.prototype.

_getInterpolatedPointInfos=function _getInterpolatedPointInfos(incidents){var _this3=this;
return incidents.map(function(incident,index){
const x=_this3._getXValueFrom(incident);
const interpolatedPoint=TimeSeries.getInterpolatedPointAtTime(_this3.snapToPoints,incident.time);
const y=_this3.verticalAxis.scale(interpolatedPoint.value)-_this3.plotArea.graphAreaBoundaries.top;

return{incident:incident,index:index,x:x,y:y};
});
};IncidentPlotterController.prototype.

_getPointInfos=function _getPointInfos(incidents){var _this4=this;
if(_.exists(this.snapToPoints)){
return this._getInterpolatedPointInfos(incidents);
}

return incidents.map(function(incident,index){return{
incident:incident,
index:index,
x:_this4._getXValueFrom(incident),
y:_this4.plotArea.graphAreaDimensions.height/2}});

};IncidentPlotterController.prototype.

_getXValueFrom=function _getXValueFrom(incident){
return this.horizontalAxis.scale(incident.time.getTime());
};IncidentPlotterController.prototype.

_getLineInfos=function _getLineInfos(){var _this5=this;
if(this.snapToPoints){
return{};
}

return{
x1:function(pointInfo){return pointInfo.x},
x2:function(pointInfo){return pointInfo.x},
y1:function(_ref){let{y:y}=_ref;return _this5.plotArea.graphAreaBoundaries.top},
y2:function(_ref2){let{y:y}=_ref2;return _this5.plotArea.graphAreaBoundaries.bottom},
class:this.class};

};IncidentPlotterController.prototype.

_getHitAreaInfos=function _getHitAreaInfos(){var _this6=this;
const halfPointHeight=this._incidentIconHeight/2;

const getYPos=function(_ref3){let{y:y}=_ref3;return _.exists(_this6.snapToPoints)?
y-halfPointHeight:
_this6.plotArea.graphAreaBoundaries.top};

const getHeight=function(_ref4){let{y:y}=_ref4;return _.exists(_this6.snapToPoints)?
_this6._incidentIconHeight:
_this6.plotArea.graphAreaDimensions.height};

return{
x:function(_ref5){let{x:x}=_ref5;return x-_this6.pointRadius},
y:getYPos,
width:this.hitAreaWidth,
height:getHeight,
fill:'transparent',
"pulsar-tooltip":!0,
"pulsar-tooltip-directive":'pulsar-incident-tooltip',
"pulsar-tooltip-data":function(point){return`controller.points[${point.index}]`},
class:this.class};

};IncidentPlotterController.prototype.

_precompileStep=function _precompileStep(d3Selection){var _this7=this;
d3Selection.selectAll('image').
data(this._getPointInfos(this.points)).
enter().
append('image').
attr({
"xlink:href":'/images/sce.svg',
width:this.pointRadius*2,
height:this.pointRadius*2,
x:function(_ref6){let{x:x}=_ref6;return x-_this7.pointRadius},
y:function(_ref7){let{y:y}=_ref7;return y-_this7.pointRadius}}).

style('pointer-events','none');
};return IncidentPlotterController}(PointPlotterDirective.Controller);


module.exports=IncidentPlotterDirective;
//# sourceMappingURL=incidentPlotterDirective.js.map
